import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/clientsmanagers/';
    const pathsList = {
        pathAdd: pathFrontEnd+'add',
        pathEdit: pathFrontEnd+'edit',
        pathView: pathFrontEnd+'view',
        endpoint: config.endpoints.backend+'governanceroom/clientsmanagers/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/clientsmanagers/delete`
    }
    
    const list = {
        labelTitle: 'Lista de Gestores de Clientes',
        labelTitleButtonAdd: 'Incluir novo gestor de cliente',
        fieldsShowOnDelete: ['name'],
        filter: profileFilter,
        canDelete: true,
        columns: [
            {
                name: 'client_manager_name',
                label: 'Nome'
            },            
            {
                name: 'instance_name',
                label: 'Cliente'
            },
            {
                name: 'status_name',
                label: 'Status'
            }
        ],  
        ...pathsList 
    };    

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
